import { ContactsSubscribeWUT } from '@wix/form-fields/viewer-wut';

export default ContactsSubscribeWUT;
